import {
    API
} from '../Api.class';

export class CampaignAnalyticsAPI extends API {

    constructor(baseUrl) {
        super(baseUrl)

    }

    async hourlyImpressions(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/campaigns/${id}/analytics/hourly/impressions`, {
            meta,
        })
    }

    async hourlyViews(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/campaigns/${id}/analytics/hourly/views`, {
            meta,
        })
    }

    async hourlyClicks(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/campaigns/${id}/analytics/hourly/clicks`, {
            meta,
        })
    }

    async latest5Performance(meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/campaigns/analytics/latest/5/performance`, {
            meta,
        })
    }


    async goalsProgress(id, goals, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/campaigns/${id}/analytics/goals/progress`, {
            params: {
                goals
            },
            meta,
        })
    }


    async last7DaysPerformance(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/campaigns/${id}/analytics/daily/performance`, {
            meta,
        })
    }

    async allTimePerformance(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/campaigns/${id}/analytics/all-time/performance`, {
            meta,
        })
    }

    async browserDistribution(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/campaigns/${id}/analytics/distribution/browser`, {
            meta,
        })
    }

    async localeDistribution(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/campaigns/${id}/analytics/distribution/locale`, {
            meta,
        })
    }
}